import { useLingui } from '../../../../../../../node_modules/@lingui/react/dist/index.mjs';
import * as React from 'react';
import { Confirmation } from '../../../components/molecules/Confirmation.mjs';
import { useMountEffect } from '../../../hooks/useMountEffect.mjs';
import { useEventCallback } from '../../GlobalContextProvider.mjs';
import { StytchEventType } from '../../../../../../core/src/public/ui.mjs';

const OTPConfirmation = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    const onEvent = useEventCallback();
    useMountEffect(()=>{
        onEvent({
            type: StytchEventType.AuthenticateFlowComplete,
            data: {}
        });
    });
    return /*#__PURE__*/ React.createElement(Confirmation, {
        text: $__i18n._({
            id: "otp.success.content"
        })
    });
};

export { OTPConfirmation };
//# sourceMappingURL=OTPConfirmation.mjs.map
